import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getPrivacyPolicy } from "../../store/actions/leadFormAction";
import CookieBanner from "../../component/CookieBanner";

export default function PrivacyPolicy() {
  const { survey_id } = useParams();
  const dispatch = useDispatch();
  const { privacyPolicy } = useSelector((state) => state.leadFormData);
  const contentRef = useRef(null);

  useEffect(() => {
    if (survey_id) {
      dispatch(getPrivacyPolicy(survey_id));
    }
  }, [survey_id, dispatch]);

  // Add click handler to intercept "Manage Cookies" clicks
  useEffect(() => {
    const element = contentRef.current;
    if (!element) return;

    const handleClick = (e) => {
      const target = e.target;
      // Check if clicked element or its parent contains "Manage Cookies" text
      const text = target.textContent?.trim();
      if (text && text.includes('Manage Cookies')) {
        e.preventDefault();
        if (window.openCookieSettings) {
          window.openCookieSettings();
        }
      }
    };

    element.addEventListener('click', handleClick);

    return () => {
      element.removeEventListener('click', handleClick);
    };
  }, [privacyPolicy]);

  return (
    <>
      <CookieBanner />
      <div className="container" style={{ padding: "24px" }}>
        <div 
          ref={contentRef}
          className="privacy-policy-html"
          dangerouslySetInnerHTML={{ __html: privacyPolicy?.privacy_content || "" }}
        />
        <style>{`
          .privacy-policy-html table { width: 100%; border-collapse: collapse; }
          .privacy-policy-html th, .privacy-policy-html td { border: 1px solid #000; padding: 8px; vertical-align: top; }
          .privacy-policy-html thead th { background: #f2f2f2; font-weight: 600; }
          /* If header row isn't wrapped in thead */
          .privacy-policy-html table tr:first-child th,
          .privacy-policy-html table tr:first-child td { background: #f2f2f2; font-weight: 600; }
          /* Make Manage Cookies text look clickable */
          .privacy-policy-html span[style*="color: rgb(0, 112, 192)"] {
            cursor: pointer;
          }
        `}</style>
      </div>
    </>
  );
}


